import React from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Typography, Divider, InfoField, ChipBox } from '@occc-app/design-system';
import { EarningMechanismVarietyPurchaseFragment } from '@occc/graphql';

import { formatProductCounting } from '../utils';

interface IVarietyPurchaseProps {
  earningMechanism: EarningMechanismVarietyPurchaseFragment;
}

export const VarietyPurchase: React.FC<IVarietyPurchaseProps> = ({ earningMechanism }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <>
      <Typography variant='subtitle1' component='h4' paragraph>
        Product Definition
      </Typography>
      {earningMechanism.products.length &&
        earningMechanism.products.map((item, index) => (
          <div key={index}>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <InfoField
                  disableTypography
                  label='Included Product Groups'
                  value={
                    <ChipBox items={item.eligibleProductGroups} onClick={onChipClick} mt={0} />
                  }
                />
              </Grid>
              <Grid item sm={3}>
                <InfoField label='Count Products By' value={formatProductCounting(item)} />
              </Grid>
              <Grid item sm>
                <InfoField label='Purchase Threshold' value={item?.purchaseThreshold} />
              </Grid>
            </Grid>
            {earningMechanism.products.length - 1 !== index && (
              <Box mx={0} mt={1} mb={2}>
                <Divider sx={{ mb: 2 }} />
                <Typography variant='subtitle1' component='p'>
                  and
                </Typography>
              </Box>
            )}
          </div>
        ))}
    </>
  );
};
